<template>
  <div class="bg-gray-200">
    <div class="container mx-auto grid grid-cols-2 w-full">
      <div class="py-2 text-md">
        <router-link to="/" class="text-green hover:underline"
          >Dashboard</router-link
        >
        <span class="text-gray-400"> / </span>
        <span class="font-bold">Registered Parts</span>
      </div>
    </div>
  </div>

  <div class="container mx-auto my-8">
    <!-- Filter and Sort Section -->
    <div class="bg-white shadow rounded-lg p-6 mb-6">
      <form @submit.prevent="search">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label
              for="number"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Number
            </label>
            <input
              type="text"
              id="number"
              v-model="filters.number"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
              placeholder="Filter by number..."
            />
          </div>

          <div>
            <label
              for="partNumber"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Part Number
            </label>
            <input
              type="text"
              id="partNumber"
              v-model="filters.partNumber"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
              placeholder="Filter by part number..."
            />
          </div>

          <div>
            <label
              for="customer"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Customer
            </label>
            <input
              type="text"
              id="customer"
              v-model="filters.customer"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
              placeholder="Filter by customer..."
            />
          </div>

          <div>
            <label
              for="sortBy"
              class="block text-sm font-medium text-gray-700 mb-1"
            >
              Sort By
            </label>
            <select
              id="sortBy"
              v-model="filters.sortBy"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
            >
              <option value="prototype_date">Prototype Date</option>
              <option value="production_date">Production Date</option>
              <option value="created_at">Creation Date</option>
            </select>
          </div>
        </div>

        <div class="flex gap-3 mt-6">
          <button
            type="submit"
            class="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2 transition-colors"
          >
            Search
          </button>
          <button
            @click="clearFilters"
            type="button"
            class="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors"
          >
            Clear Filters
          </button>
        </div>
      </form>
    </div>

    <table class="min-w-full divide-y divide-gray-300 shadow rounded">
      <thead class="bg-gray-50">
        <tr>
          <th
            scope="col"
            class="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
          >
            Number
          </th>
          <th
            scope="col"
            class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
          >
            Part Number
          </th>
          <th
            scope="col"
            class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
          >
            Customer
          </th>
          <th
            scope="col"
            class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
          >
            Created At
          </th>
          <th
            scope="col"
            class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
          >
            Prototype Date
          </th>
          <th
            scope="col"
            class="whitespace-nowrap px-2 py-3.5 text-left text-sm font-semibold text-gray-900"
          >
            Production Date
          </th>
        </tr>
      </thead>
      <tbody
        class="divide-y divide-gray-200 bg-white"
        v-if="registered_parts.length > 0"
      >
        <template v-for="item in registered_parts" :key="item.id">
          <tr>
            <td
              class="whitespace-nowrap py-2 pl-4 pr-3 text-sm text-gray-500 sm:pl-6"
            >
              {{ item.number }}
            </td>
            <td
              class="whitespace-nowrap px-2 py-2 text-sm font-medium text-gray-900"
            >
              <p>
                {{ item?.part?.part_number }}
              </p>
              <p class="text-xs text-gray-700">
                {{ item?.part?.description || item?.part?.part?.description }}
              </p>
            </td>
            <td class="px-2 py-2 text-sm text-gray-900">
              <span>
                {{ item?.customer }}
              </span>
            </td>
            <td
              class="whitespace-nowrap px-2 py-3.5 pr-4 text-sm text-gray-900"
            >
              {{ item.human_created_at }}
            </td>
            <td
              class="whitespace-nowrap px-2 py-3.5 pr-4 text-sm text-gray-900"
            >
              {{ item.human_prototype_date }}
            </td>
            <td
              class="whitespace-nowrap px-2 py-3.5 pr-4 text-sm text-gray-900"
            >
              {{ item.human_production_date }}
            </td>
          </tr>
        </template>
      </tbody>
      <tbody
        class="divide-y divide-gray-200 bg-white"
        v-if="registered_parts === 0"
      >
        <tr>
          <td
            colspan="3"
            class="whitespace-nowrap text-sm text-gray-500 sm:pl-6 text-center p-8"
          >
            No data found
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data: () => {
    return {
      registered_parts: [],
      filters: {
        number: "",
        partNumber: "",
        customer: "",
        sortBy: "created_at",
      },
    };
  },

  async mounted() {
    document.title = "MLE Rep Center | Registered Parts";
    await this.getRegisteredParts();
  },

  methods: {
    async getRegisteredParts() {
      const params = {};

      // Add filters to params if they have values
      if (this.filters.number) params.number = this.filters.number;
      if (this.filters.partNumber) params.part_number = this.filters.partNumber;
      if (this.filters.customer) params.customer = this.filters.customer;
      if (this.filters.sortBy) params.sort_by = this.filters.sortBy;

      const resp = await axios.get("api/rep-center/registered-parts", {
        params,
      });
      this.registered_parts = resp.data.registered_parts;
    },

    search() {
      this.getRegisteredParts();
    },

    clearFilters() {
      this.filters = {
        number: "",
        partNumber: "",
        customer: "",
        sortBy: "created_at",
      };
      this.getRegisteredParts();
    },
  },
};
</script>
